import React from 'react'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'
import { useTabNavigate } from 'hooks/useTabNavigate'

import { CampaignTab } from '../CampaignSlug'

interface Props {
  data: MarketingCampaignDetailDto
  tab: CampaignTab
}

export const CampaignNavigation: React.FC<Props> = (props) => {
  const tabNavigate = useTabNavigate()

  return (
    <div>
      <NavigationHeader />
      <Tabs value={props.tab} onValueChange={tabNavigate} className='mt-2'>
        <TabsList>
          <TabsTrigger value={CampaignTab.DETAILS}>Details</TabsTrigger>

          {props.data && (
            <>
              <TabsTrigger value={CampaignTab.PARTICIPATING_COUNTRIES}>
                Participating Countries
              </TabsTrigger>

              <TabsTrigger value={CampaignTab.RESULTS}>Results</TabsTrigger>
            </>
          )}

          {props.data.luckyDrawConfiguration && (
            <TabsTrigger value={CampaignTab.REWARDS}>Rewards</TabsTrigger>
          )}
        </TabsList>
      </Tabs>
    </div>
  )
}
